<template>
 <div>
    <loader :show="enviando"/>
    <b-modal  v-model="mostrar" size="m" hide-footer  hide-header-close no-close-on-backdrop>   
    <b-card-body>
      <b-row>
          <b-col md="12" v-if="nuevo || editarSevac">
            <b-form-group label="Título de la pregunta" >
               <b-form-input
                @change="cambios = true"
                v-model="titulo"
                :class="{invalid_input: $v.titulo.$error}"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12" v-if="nuevo || editarArchivo" >
            <b-form-file
              v-model="file"
              :state="Boolean(file)"
              placeholder="Escoja un archivo desde su equipo"
              browse-text="Selecciona"
            ></b-form-file>
          </b-col>

         
        </b-row>
        <br>
        <b-col md="12">
        <b-row style="text-align: center">
         <b-col>
            <b-button variant="danger"  size="sm" @click="$emit('cancelar')"  >Cancelar</b-button>
          </b-col>
          <b-col>
            <b-button variant="primary" v-if="nuevo" size="sm" @click="guadar()" :disabled="enviando">Guardar</b-button>
            <b-button variant="primary" v-if="editarSevac" size="sm" @click="guardarTitulo()" :disabled="enviando">Guardar</b-button>
            <b-button variant="primary" v-if="editarArchivo" size="sm" @click="guadarArchivo(editarArchivo)" :disabled="enviando">Guardar</b-button>
            <br />
            <p v-if="cambios" class="error-text">  <i>No se han guardado los cambios</i> </p>
          </b-col>   
        </b-row>
        </b-col>
    </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import Loader from "../Loader";
import { mapGetters } from "vuex";
import "vue-datetime/dist/vue-datetime.css";
import { required } from "vuelidate/lib/validators";


export default {
  name:"agregarPregunta",
  components: { Loader},
  props: ["mostrar","nuevo", "editarSevac", "editarArchivo", "trimestre"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
 
  validations:{
   
     titulo:{required},
    
  },
  data: function() {
    return {
      enviando: false,
      cambios: false,
      file:null,
      titulo: null,
      terminado: true,
      progreso: 0,
        
    };
  },
  methods: {
   
    guadar() {
      this.$v.$touch();  
      if (!this.$v.$invalid) {
        this.enviando = true;
        let data = new FormData();
        data.append("archivo", this.file);
        data.append("titulo",this.titulo)
    
        axios.post(this.httpURL + '/tesoreria/trimestre/'+this.trimestre+'/sevac', data,
        {
          headers: { token: this.sessionToken }
        })
        .then(res => {
          //console.log(res);
          this.enviando = false;
          if(res.data.ok){
            this.$emit('documentoCargado',res.data.pregunta);
            this.$emit('cancelar')
          }
          else{
             this.$notify({ group: "foo",  type: "error", duration: 1500, speed: 500,text: res.data.mensaje });
          }

        })
        .catch(err => {
          err;
          this.$notify({ group: "gral_notif", type: "error",duration: 1500, speed: 500, text: "No se pudo establecer una conexión al servidor."});
        });
      }
     
    },
    guardarTitulo() {
      this.$v.$touch();  
      if (!this.$v.$invalid) {
      this.enviando = true;
     
      axios.put(this.httpURL + "/tesoreria/sevac/titulo/"+this.editarSevac._id,
        {titulo:this.titulo}, 
        {headers: { token: this.sessionToken }})
        .then(res => {
          this.enviando = false;
          this.$emit('editado',res.data.sevac);
          this.$emit('cancelar')
        })
        .catch(err => {
          this.$notify({ group: "gral_notif", type: "error", duration: 1500, speed: 500, text: "No se pudo establecer una conexión al servidor." });
        });
      }
      
    },
    guadarArchivo(id) {
      this.enviando = true;
      let data = new FormData();
      data.append("archivo", this.file);
      axios.post(this.httpURL + "/tesoreria/trimestre/"+this.trimestre+"/sevac/archivo/"+id, data,
        { headers: { token: this.sessionToken }})
        .then(res => {
         // console.log(res)
         this.enviando = false;
         if(res.data.ok){
            this.$emit('editado',res.data.sevac);
            this.$emit('cancelar')
          }
        })
        .catch(err => {
         this.enviando = false; 
          this.$notify({group: "gral_notif",type: "error", duration: 1500, speed: 500, text: "No se pudo establecer una conexión al servidor."});
        });
    }   
  },
  created() {
    this.editarSevac ? this.titulo = this.editarSevac.titulo : null;
  }
};
</script>